module.exports = __webpack_public_path__ + "img/6-2.759955fd.png";